import { render, staticRenderFns } from "./PositionChart.vue?vue&type=template&id=63fa297e&"
import script from "./PositionChart.vue?vue&type=script&lang=js&"
export * from "./PositionChart.vue?vue&type=script&lang=js&"
import style0 from "./PositionChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports